import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { Col } from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import Avatar from '../Avatar';
import CurrencyConverter from '../CurrencyConverter';

import messages from '../../locale/jsonMessages';
import { photosShow } from '../../helpers/photosShow';
import { cancellationGuestData, getPriceWithDiscount } from '../../helpers/cancellationData';
import { fileuploadDir } from '../../config';

import defaultPic from './large_no_image.jpeg';
import steeringIcon from '/public/SiteIcons/steeringIcon.svg';
import starIcon from '/public/SiteIcons/star.svg';
import nonRefund from '/public/SiteIcons/nonRefund.svg';
import refund from '/public/SiteIcons/refund.svg';
import { formatTime } from '../../helpers/formatting';

import cs from '../../components/commonStyle.css';
import s from './Cancellation.css';

const DetailsForGuest = (props) => {
  const { initialize, reservationId, confirmationCode, threadId, userType, title, listId, checkIn, checkOut, guests, profileId, firstName, hostEmail, guestName } = props
  const { picture, basePrice, delivery, guestServiceFee, hostServiceFee, total, currency, cancelData, holdeData, discount, startTime, endTime, serviceFees } = props
  const { base, rates, hostServiceFeeValue, hostServiceFeeType, carType, transmission, starRatingValue, isSpecialPriceAverage } = props;
  const { promoCodeType, promoDiscount } = props;

  const [nonRefundableNightPrice, setNonRefundableNightPrice] = useState(0);
  const [refundableNightPrice, setRefundableNightPrice] = useState(0);
  const [dayPrice, setDayPrice] = useState(0);

  useEffect(() => {
    if (!cancelData) return;

    let refundablePrice = 0, nonRefundablePrice = 0, cancellationData = {}, updatedGuestFee = 0, updatedHostFee = 0, payoutToHost = 0, subtotal = 0;
    let priceForDays = 0, isSpecialPriceAssigned = false, formattedStartTime, formattedEndTime, bookingSpecialPricing = [], updatedPromoDiscount = 0, updatedPromoCodeType;

    if (startTime && endTime) {
      formattedStartTime = formatTime(startTime);
      formattedEndTime = formatTime(endTime);
    }

    let cleaningPrice = delivery || 0;

    if (holdeData?.bookingSpecialPricing) {
      holdeData.bookingSpecialPricing.forEach((item) => {
        let currentPrice = item.blockedDates ? Number(item.isSpecialPrice) : Number(basePrice);
        bookingSpecialPricing.push({ blockedDates: item, isSpecialPrice: currentPrice });
        if (item.blockedDates) isSpecialPriceAssigned = true;
      });
    }

    if (isSpecialPriceAssigned) {
      priceForDays = bookingSpecialPricing.reduce((sum, item) => sum + Number(item.isSpecialPrice), 0);
    } else {
      priceForDays = Number(basePrice) * Number(cancelData.nights);
    }

    const calculatedDayPrice = getPriceWithDiscount({
      basePrice: isSpecialPriceAverage || basePrice,
      discount,
      nights: cancelData.nights,
    });

    const cancellationGuestObj = cancellationGuestData({
      remainingNights: cancelData.remainingNights,
      nights: cancelData.nights,
      priceForDays,
      accomodation: cancelData.accomodation,
      isCleaingPrice: cleaningPrice,
      guestServiceFee,
      guestFees: cancelData.guestFees,
      discount,
      hostServiceFee,
      hostServiceFeeValue,
      hostServiceFeeType,
      basePrice: calculatedDayPrice,
      total,
      policyName: cancelData.policyName,
      interval: cancelData.interval,
      priorDays: cancelData.priorDays,
      serviceFees,
      base,
      rates,
      currency,
      promoDiscount,
      promoCodeType
    });

    refundablePrice = cancellationGuestObj.refundableNightPrice;
    nonRefundablePrice = cancellationGuestObj.nonRefundableNightPrice;
    payoutToHost = cancellationGuestObj.payoutToHost;
    updatedHostFee = cancellationGuestObj.updatedHostFee;
    updatedGuestFee = cancellationGuestObj.updatedGuestFee;
    updatedPromoDiscount = cancellationGuestObj.updatedPromoDiscount,
      updatedPromoCodeType = cancellationGuestObj.updatedPromoCodeType
    subtotal = total + guestServiceFee;

    cancellationData = {
      reservationId,
      cancellationPolicy: cancelData.defaultPolicyName || cancelData.policyName,
      refundToGuest: refundablePrice,
      payoutToHost,
      guestServiceFee: updatedGuestFee,
      hostServiceFee: updatedHostFee,
      total: subtotal,
      currency,
      threadId,
      cancelledBy: 'renter',
      checkIn,
      checkOut,
      guests,
      guestName,
      hostName: firstName,
      listTitle: title,
      confirmationCode,
      hostEmail,
      startTime,
      endTime,
      promoDiscount: updatedPromoDiscount,
      promoCodeType: updatedPromoCodeType
    };

    initialize('CancellationForm', cancellationData, true);
    setNonRefundableNightPrice(nonRefundablePrice);
    setRefundableNightPrice(refundablePrice);
    setDayPrice(calculatedDayPrice);

  }, []);

  const { policyName, defaultPolicyName, policyContent } = cancelData || {};


  const coverImage = holdeData?.listData?.listPhotos?.find(o => o.id == holdeData.listData.coverPhoto);
  const imagePath = photosShow(fileuploadDir);
  const path = `${imagePath}x_medium_`;
  let showImage;

  if (coverImage) {
    showImage = path + coverImage.name;
  } else if (holdeData?.listData?.listPhotos?.length > 0) {
    showImage = path + holdeData.listData.listPhotos[0].name;
  } else {
    showImage = defaultPic;
  }

  return (
    <div>
      <Col xs={12} sm={5} md={5} lg={5}>
        <div className={cx(s.cancelRightCol, cs.commonBorderSection, cs.spaceBottom3)}>
          <div className={cx(s.bgCover, cs.spaceBottom3)}>
            <a href={`/cars/${listId}`} target="_blank">
              <div className={s.cancelBg} style={{ backgroundImage: `url(${showImage})` }} />
            </a>
            <div className={cx(s.profileAvatarSection, 'cancelTripAvatarSecRTL')}>
              <Avatar
                source={picture}
                height={44}
                width={44}
                title={firstName}
                className={cx(s.profileAvatar, cs.profileAvatarLinkSmall)}
                withLink
                linkClassName={cx(s.profileAvatarLink, s.profileLinkPadding)}
                profileId={profileId}
              />
            </div>
          </div>
          <div className={cx(cs.listingCardCarTypeAndTransmissionLabelFlexContainer, cs.spaceBottom1)}>
            <div className={cs.textFlow}>
              <img src={steeringIcon} alt="Steering" className={cs.carTypeIcon} />{' '}
              <span>{carType}</span>
            </div>
            <div className={cx(cs.textFlow, cs.transmissionLabelText, 'transmissionLabelTextRtl')}>{transmission}</div>
          </div>
          <div className={cx(s.textTruncate, s.listingTitleSec)}>
            <a className={cx(s.listingTitle, cs.commonContentText, cs.fontWeightBold)} href={`/cars/${listId}`} target="_blank">
              {title}
            </a>
          </div>
          {starRatingValue > 0 && (
            <div className={cs.dFlex}>
              <img src={starIcon} className={cx(s.starIcon, 'cancelTripStarIconRTL')} alt="Star" />
              <span className={cx(cs.commonContentText, cs.fontWeightNormal)}>{starRatingValue}</span>
            </div>
          )}
        </div>

        <div>
          <div className={cx(s.cancelPayDetails, cs.spaceBottom3, {
            [s.hostFundSec]: refundableNightPrice <= 0,
            [s.guestFundSec]: refundableNightPrice > 0
          })}>
            {nonRefundableNightPrice > 0 && (
              <>
                <div className={cx(cs.dFlex, cs.spaceBottom9)}>
                  <div className={cx(s.leftSecWidth, s.textLeft, cs.dFlex, 'textAlignRightRTL')}>
                    <img src={nonRefund} className={cx(s.missedEarningsIcon, 'missedEarningsIconRTL')} alt="Non Refundable" />
                    <span className={cx(cs.commonContentText, cs.fontWeightBold)}>
                      <FormattedMessage {...messages.nonRefundable} />
                    </span>
                  </div>
                  <div className={cx(s.rightSecWidth, s.textRight, 'textAlignLeftRTL')}>
                    <span className={cx(cs.commonContentText, cs.fontWeightBold, s.strikeOutLine)}>
                      <CurrencyConverter amount={nonRefundableNightPrice} from={currency} />
                    </span>
                  </div>
                </div>
                {refundableNightPrice === 0 && (
                  <p className={cx(cs.commonSmallText, cs.fontWeightNormal)}>
                    <FormattedMessage {...messages.payoutCost} />
                  </p>
                )}
              </>
            )}
            {(nonRefundableNightPrice > 0 && refundableNightPrice > 0) && <hr className={s.lineBg} />}
            {refundableNightPrice > 0 && (
              <>
                <div className={cx(cs.dFlex, cs.spaceBottom9)}>
                  <div className={cx(s.leftSecWidth, s.textLeft, cs.dFlex, 'textAlignRightRTL')}>
                    <img src={refund} className={cx(s.missedEarningsIcon, 'missedEarningsIconRTL')} alt="Refundable" />
                    <span className={cx(cs.commonContentText, cs.fontWeightBold)}>
                      <FormattedMessage {...messages.refundable} />
                    </span>
                  </div>
                  <div className={cx(s.rightSecWidth, s.textRight, 'textAlignLeftRTL')}>
                    <span className={cx(cs.commonContentText, cs.fontWeightBold)}>
                      <CurrencyConverter amount={refundableNightPrice} from={currency} />
                    </span>
                  </div>
                </div>
                <p className={cx(cs.commonSmallText, cs.fontWeightNormal)}>
                  <FormattedMessage {...messages.refundCost} />
                </p>
              </>
            )}
          </div>

          <div className={cx(s.cancellationPolicySec, cs.spaceBottom5)}>
            <div className={cx(cs.commonContentText, cs.fontWeightBold, cs.spaceBottom1)}>
              <span><FormattedMessage {...messages.cancellationPolicy} />:{' '}</span>
              <span>
                <a href={`/cancellation-policies/${encodeURIComponent(defaultPolicyName || policyName)}`} target="_blank" className={cs.siteLinkColor}>
                  {policyName}
                </a>
              </span>
            </div>
            <div className={cx(cs.commonMediumText, cs.fontWeightNormal, s.cancelPolicyContent)}>
              {policyContent}
            </div>
          </div>
        </div>
      </Col>
    </div>
  );
};

DetailsForGuest.propTypes = {
  formatMessage: PropTypes.any,
  reservationId: PropTypes.number.isRequired,
  confirmationCode: PropTypes.number.isRequired,
  threadId: PropTypes.number.isRequired,
  userType: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  listId: PropTypes.number.isRequired,
  checkIn: PropTypes.string.isRequired,
  checkOut: PropTypes.string.isRequired,
  guests: PropTypes.number.isRequired,
  profileId: PropTypes.number.isRequired,
  firstName: PropTypes.string.isRequired,
  hostEmail: PropTypes.string.isRequired,
  guestName: PropTypes.string.isRequired,
  picture: PropTypes.string,
  basePrice: PropTypes.number.isRequired,
  delivery: PropTypes.number.isRequired,
  guestServiceFee: PropTypes.number.isRequired,
  hostServiceFee: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  cancelData: PropTypes.shape({
    policyName: PropTypes.string.isRequired,
    accomodation: PropTypes.number.isRequired,
    guestFees: PropTypes.number.isRequired,
    remainingNights: PropTypes.number,
    interval: PropTypes.number.isRequired,
    nights: PropTypes.number.isRequired,
  }).isRequired
};

const mapState = (state) => ({
  serviceFees: state.book.serviceFees,
  base: state.currency.base,
  rates: state.currency.rates,
});

const mapDispatch = {
  initialize
};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(DetailsForGuest)));
